// src/pages/ChoosePlan.jsx
import { useNavigate } from "react-router-dom";
import "./styles/quickbuy.scss";

export default function ChoosePlan() {
  const navigate = useNavigate();

  const plans = [
    { 
      key: "CPA", 
      title: "CPA 美國註冊會計師", 
      parentId: 1, 
      desc: "最完整的美國會計師課程",
      img: "./homeImg/news1.png" 
    },
    { 
      key: "CMA", 
      title: "CMA 美國管理會計師", 
      parentId: 2, 
      desc: "專注管理會計與決策",
      img: "./homeImg/news4.png" 

    },
    { 
      key: "EA",  
      title: "EA 美國註冊報稅師",  
      parentId: 3, 
      desc: "稅務領域專業證照",
      img: "./homeImg/news6.png" 

    },
    { 
      key: "CPE",  
      title: "CPE 美國註冊會計師",  
      parentId: 4, 
      desc: "必修的進修課程",
      img: "./homeImg/news2.png" 

    },
    { 
      key: "CSU",  
      title: "學分班",  
      parentId: 5, 
      desc: "合作學分班",
      img: "./homeImg/news3.png" 

    },
    { 
      key: "US Tax",  
      title: "美國稅務入門全攻略",  
      parentId: 6, 
      desc: "從零理解美稅制度邏輯",
      img: "./homeImg/news5.png" 

    },
    { 
      key: "CIA",  
      title: "CIA 國際內部稽核師",  
      parentId: 8, 
      desc: "國際企業內稽指定證照",
      img: "./homeImg/news7.png" 

    },
    { 
      key: "美稅實務操作訓練營",  
      title: "美稅實務操作訓練營",  
      parentId: 9, 
      desc: "跨境資產規劃",
      img: "./homeImg/news8.png" 

    },
  ];

  const handleChoose = (plan) => {
    localStorage.setItem("selectedPlan", plan.key);
    navigate(`/registration/plan?parent_id=${plan.parentId}`);
  };

  return (
    <div className="container choose-plan">
      <h2 className="text-center page-title">請選擇您要購買的方案</h2>
      <div className="row m-auto">
        {plans.map((plan) => (
          <div key={plan.key} className="col-sm-4">
            <div
              className="plan-card"
              onClick={() => handleChoose(plan)}
            >
              

              {/* 標題區 */}
              <div className="plan-header mb-5">{plan.key}</div>
              {/* 卡片圖片 */}
              <div className="plan-img-wrapper">
                <img src={plan.img} alt={plan.title} className="plan-img" />
              </div>

              {/* 內容區 */}
              <div className="plan-body">
                <h4 className="plan-title">{plan.title}</h4>
                <p className="plan-desc">{plan.desc}</p>
                <button className="btn btn-primary btn-block">前往合約</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}